import type { FieldValues, Path, PathValue } from "react-hook-form";
import { TextField } from "../../TextField";
import type { PhoneFieldProps } from "../lib/type";
import { MaskedField } from "../../MaskedField";

const ukrainePhoneRegex = /^(?:\+380|380|0)(?:39|50|63|66|67|68|73|77|75|91|92|93|94|95|96|97|98|99)\d{7}$/;

export const PhoneField = <T extends FieldValues>({
    defaultValue = "",
    label = "Номер телефону",
    hintIcon = false,
    mask = "+38 (000) 000 00 00",
    toggleHintArea,
    closeHintArea,
    openHintArea,
    autoComplete,
    ...rest
}: PhoneFieldProps<T>) => {
    return (
        <TextField
            {...rest}
            autoComplete={"tel"}
            InputProps={{
                inputComponent: MaskedField as any,
                inputProps: {
                    mask,
                },
                disableUnderline: true,
                autoComplete: "tel",
                inputMode: "tel",
            }}
            label={label}
            hintIcon={hintIcon}
            defaultValue={defaultValue as PathValue<T, Path<T>>}
            toggleHintArea={toggleHintArea}
            closeHintArea={closeHintArea}
            openHintArea={openHintArea}
            pattern={ukrainePhoneRegex}
            patternErrorMessage="Номер телефону має бути у форматі +380 (XX) XXX XX XX"
        />
    );
};
